import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client/react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { AuthProvider, useAuth } from './context/AuthContext';
import client from './apollo';
import theme from './theme';
import Login from './pages/Login/Login';
import DayView from './pages/DayView/DayView';
import Dashboard from './pages/Dashboard/Dashboard';
import Notes from './pages/Notes/Notes';
import Settings from './pages/Settings/Settings';
import Calendar from './pages/Calendar/Calendar';
import People from './pages/People/People';
import Languages from './pages/Languages/Languages';
import GymTracker from './pages/GymTracker/GymTracker';
import Recipes from './pages/Recipes/Recipes';

const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return null;
  }

  return user ? <>{children}</> : <Navigate to="/login" />;
};

const App: React.FC = () => {
  return (
    <ApolloProvider client={client}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <Router>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/"
                element={
                  <PrivateRoute>
                    <Dashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path="/day-view/:date?"
                element={
                  <PrivateRoute>
                    <DayView />
                  </PrivateRoute>
                }
              />
              <Route
                path="/notes"
                element={
                  <PrivateRoute>
                    <Notes />
                  </PrivateRoute>
                }
              />
              <Route
                path="/settings"
                element={
                  <PrivateRoute>
                    <Settings />
                  </PrivateRoute>
                }
              />
              <Route
                path="/calendar"
                element={
                  <PrivateRoute>
                    <Calendar />
                  </PrivateRoute>
                }
              />
              <Route
                path="/people"
                element={
                  <PrivateRoute>
                    <People />
                  </PrivateRoute>
                }
              />
              <Route
                path="/languages"
                element={
                  <PrivateRoute>
                    <Languages />
                  </PrivateRoute>
                }
              />
              <Route
                path="/gym"
                element={
                  <PrivateRoute>
                    <GymTracker />
                  </PrivateRoute>
                }
              />
              <Route
                path="/recipes"
                element={
                  <PrivateRoute>
                    <Recipes />
                  </PrivateRoute>
                }
              />
            </Routes>
          </Router>
        </AuthProvider>
      </ThemeProvider>
    </ApolloProvider>
  );
};

export default App;